// extracted by mini-css-extract-plugin
export default {"block":"PagePlug_block__-mfeX","img":"PagePlug_img__uP72S","text":"PagePlug_text__OyJGy"};